import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

function Divider({ classes }) {
  return <hr className={classes.root} />;
}

Divider.propTypes = {
  classes: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    margin: [[theme.spacing.medium, 0]],
    border: 'none',
    height: 1,
    background: theme.palette.grey.minBlack,
  },
});

export default injectSheet(stylesheet)(Divider);



// WEBPACK FOOTER //
// ./src/site-render/src/Divider/Divider.js